import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_origin1s47cvkxjaphr as get_origin } from './URLBuilder.web.mjs';
import {
  Urlowwyg1lanrqp as Url,
  appendUrlFullPath2slafmfwiwvmw as appendUrlFullPath,
  appendUserAndPassword2m6va0hoftk5 as appendUserAndPassword,
} from './URLUtils.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Companion_getInstance25cbdbruarm2m as Companion_getInstance } from './Parameters.mjs';
import {
  encodeURLParameter1u3y18ab0iker as encodeURLParameter,
  encodeURLQueryComponent1fjq9wb8rn8hq as encodeURLQueryComponent,
  encodeURLPathPart6y0hlser8v0t as encodeURLPathPart,
  decodeURLPart53igalrwb9si as decodeURLPart,
  decodeURLQueryComponent1psnpw5x5jp3h as decodeURLQueryComponent,
} from './Codecs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  encodeParameters1kx5voquz3xxo as encodeParameters,
  UrlDecodedParametersBuilder18hwlye3pykgz as UrlDecodedParametersBuilder,
} from './UrlDecodedParametersBuilder.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstanceudl2ftapa8hy as Companion_getInstance_0 } from './URLProtocol.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Url1652zsz51o0h6 as Url_0 } from './Url.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  startsWith1bgirhbedtv2y as startsWith,
  split3d3yeauc4rm2n as split,
  isBlank1dvkhjjvox3p0 as isBlank,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  toMutableList20rdgwi7d3cwi as toMutableList,
  first58ocm7j58k3q as first,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { get_ROOT_PATH1cfc0dxvljm6a as get_ROOT_PATH } from './URLParser.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function applyOrigin($this) {
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_0 = $this.host_1;
  if (charSequenceLength(this_0) > 0) {
    tmp = true;
  } else {
    tmp = $this.get_protocol_mv93kx_k$().name_1 === 'file';
  }
  if (tmp)
    return Unit_instance;
  $this.host_1 = Companion_getInstance_1().originUrl_1.host_1;
  if ($this.protocolOrNull_1 == null)
    $this.protocolOrNull_1 = Companion_getInstance_1().originUrl_1.protocolOrNull_1;
  if ($this.port_1 === 0) {
    $this.set_port_gcpocq_k$(Companion_getInstance_1().originUrl_1.specifiedPort_1);
  }
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.originUrl_1 = Url(get_origin(this));
        this.INITIAL_CAPACITY_1 = 256;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_1() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var URLBuilderClass;
function URLBuilder() {
  if (URLBuilderClass === VOID) {
    class $ {
      constructor(protocol, host, port, user, password, pathSegments, parameters, fragment, trailingQuery) {
        Companion_getInstance_1();
        protocol = protocol === VOID ? null : protocol;
        host = host === VOID ? '' : host;
        port = port === VOID ? 0 : port;
        user = user === VOID ? null : user;
        password = password === VOID ? null : password;
        pathSegments = pathSegments === VOID ? emptyList() : pathSegments;
        parameters = parameters === VOID ? Companion_getInstance().Empty_1 : parameters;
        fragment = fragment === VOID ? '' : fragment;
        trailingQuery = trailingQuery === VOID ? false : trailingQuery;
        this.host_1 = host;
        this.trailingQuery_1 = trailingQuery;
        this.port_1 = port;
        this.protocolOrNull_1 = protocol;
        var tmp = this;
        tmp.encodedUser_1 = user == null ? null : encodeURLParameter(user);
        var tmp_0 = this;
        tmp_0.encodedPassword_1 = password == null ? null : encodeURLParameter(password);
        this.encodedFragment_1 = encodeURLQueryComponent(fragment);
        var tmp_1 = this;
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(pathSegments, 10));
        var _iterator__ex2g4s = pathSegments.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$2 = encodeURLPathPart(item);
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        tmp_1.encodedPathSegments_1 = destination;
        this.encodedParameters_1 = encodeParameters(parameters);
        this.parameters_1 = new (UrlDecodedParametersBuilder())(this.encodedParameters_1);
      }
      set_port_gcpocq_k$(value) {
        // Inline function 'kotlin.require' call
        if (!(0 <= value ? value <= 65535 : false)) {
          var message = 'Port must be between 0 and 65535, or 0 if not set. Provided: ' + value;
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        this.port_1 = value;
      }
      set_protocol_4rvp64_k$(value) {
        this.protocolOrNull_1 = value;
      }
      get_protocol_mv93kx_k$() {
        var tmp0_elvis_lhs = this.protocolOrNull_1;
        return tmp0_elvis_lhs == null ? Companion_getInstance_0().HTTP_1 : tmp0_elvis_lhs;
      }
      set_user_5x9835_k$(value) {
        var tmp = this;
        tmp.encodedUser_1 = value == null ? null : encodeURLParameter(value);
      }
      get_user_wovspg_k$() {
        var tmp0_safe_receiver = this.encodedUser_1;
        return tmp0_safe_receiver == null ? null : decodeURLPart(tmp0_safe_receiver);
      }
      get_password_bodifw_k$() {
        var tmp0_safe_receiver = this.encodedPassword_1;
        return tmp0_safe_receiver == null ? null : decodeURLPart(tmp0_safe_receiver);
      }
      get_fragment_bxnb4p_k$() {
        return decodeURLQueryComponent(this.encodedFragment_1);
      }
      get_pathSegments_2e2s6m_k$() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.encodedPathSegments_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$2 = decodeURLPart(item);
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        return destination;
      }
      set_encodedParameters_t3ck1r_k$(value) {
        this.encodedParameters_1 = value;
        this.parameters_1 = new (UrlDecodedParametersBuilder())(value);
      }
      buildString_xr87oh_k$() {
        applyOrigin(this);
        return appendTo(this, StringBuilder().new_kotlin_text_StringBuilder_wcb3z_k$(256)).toString();
      }
      toString() {
        return appendTo(this, StringBuilder().new_kotlin_text_StringBuilder_wcb3z_k$(256)).toString();
      }
      build_1k0s4u_k$() {
        applyOrigin(this);
        return new (Url_0())(this.protocolOrNull_1, this.host_1, this.port_1, this.get_pathSegments_2e2s6m_k$(), this.parameters_1.build_1k0s4u_k$(), this.get_fragment_bxnb4p_k$(), this.get_user_wovspg_k$(), this.get_password_bodifw_k$(), this.trailingQuery_1, this.buildString_xr87oh_k$());
      }
    }
    initMetadataForClass($, 'URLBuilder', URLBuilder);
    URLBuilderClass = $;
  }
  return URLBuilderClass;
}
function get_authority(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  this_0.append_22ad7x_k$(get_encodedUserAndPassword(_this__u8e3s4));
  this_0.append_22ad7x_k$(_this__u8e3s4.host_1);
  if (!(_this__u8e3s4.port_1 === 0) && !(_this__u8e3s4.port_1 === _this__u8e3s4.get_protocol_mv93kx_k$().defaultPort_1)) {
    this_0.append_22ad7x_k$(':');
    this_0.append_22ad7x_k$(_this__u8e3s4.port_1.toString());
  }
  return this_0.toString();
}
function appendTo(_this__u8e3s4, out) {
  out.append_jgojdo_k$(_this__u8e3s4.get_protocol_mv93kx_k$().name_1);
  switch (_this__u8e3s4.get_protocol_mv93kx_k$().name_1) {
    case 'file':
      appendFile(out, _this__u8e3s4.host_1, get_encodedPath(_this__u8e3s4));
      appendUrlFullPath(out, '', _this__u8e3s4.encodedParameters_1, _this__u8e3s4.trailingQuery_1);
      break;
    case 'mailto':
      appendMailto(out, get_encodedUserAndPassword(_this__u8e3s4), _this__u8e3s4.host_1);
      return out;
    case 'about':
      appendPayload(out, _this__u8e3s4.host_1);
      return out;
    case 'tel':
      appendPayload(out, _this__u8e3s4.host_1);
      return out;
    case 'data':
      appendPayload(out, _this__u8e3s4.host_1);
      return out;
    default:
      out.append_jgojdo_k$('://');
      out.append_jgojdo_k$(get_authority(_this__u8e3s4));
      appendUrlFullPath(out, get_encodedPath(_this__u8e3s4), _this__u8e3s4.encodedParameters_1, _this__u8e3s4.trailingQuery_1);
      break;
  }
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_0 = _this__u8e3s4.encodedFragment_1;
  if (charSequenceLength(this_0) > 0) {
    out.append_58al37_k$(_Char___init__impl__6a9atx(35));
    out.append_jgojdo_k$(_this__u8e3s4.encodedFragment_1);
  }
  return out;
}
function get_encodedUserAndPassword(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  appendUserAndPassword(this_0, _this__u8e3s4.encodedUser_1, _this__u8e3s4.encodedPassword_1);
  return this_0.toString();
}
function appendFile(_this__u8e3s4, host, encodedPath) {
  _this__u8e3s4.append_jgojdo_k$('://');
  _this__u8e3s4.append_jgojdo_k$(host);
  if (!startsWith(encodedPath, _Char___init__impl__6a9atx(47))) {
    _this__u8e3s4.append_58al37_k$(_Char___init__impl__6a9atx(47));
  }
  _this__u8e3s4.append_jgojdo_k$(encodedPath);
}
function set_encodedPath(_this__u8e3s4, value) {
  _this__u8e3s4.encodedPathSegments_1 = isBlank(value) ? emptyList() : value === '/' ? get_ROOT_PATH() : toMutableList(split(value, charArrayOf([_Char___init__impl__6a9atx(47)])));
}
function get_encodedPath(_this__u8e3s4) {
  return joinPath(_this__u8e3s4.encodedPathSegments_1);
}
function appendMailto(_this__u8e3s4, encodedUser, host) {
  _this__u8e3s4.append_jgojdo_k$(':');
  _this__u8e3s4.append_jgojdo_k$(encodedUser);
  _this__u8e3s4.append_jgojdo_k$(host);
}
function appendPayload(_this__u8e3s4, host) {
  _this__u8e3s4.append_jgojdo_k$(':');
  _this__u8e3s4.append_jgojdo_k$(host);
}
function joinPath(_this__u8e3s4) {
  if (_this__u8e3s4.isEmpty_y1axqb_k$())
    return '';
  if (_this__u8e3s4.get_size_woubt6_k$() === 1) {
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = first(_this__u8e3s4);
    if (charSequenceLength(this_0) === 0)
      return '/';
    return first(_this__u8e3s4);
  }
  return joinToString(_this__u8e3s4, '/');
}
//region block: exports
export {
  URLBuilder as URLBuilder2mz8zkz4u9ray,
  get_authority as get_authorityakhc3pgcrb9j,
  set_encodedPath as set_encodedPath3q0i8nsv3a7qy,
};
//endregion

//# sourceMappingURL=URLBuilder.mjs.map
